// Module
var code = `<div class="footer-close-position-screen">
    <reactFormLabel label="{{.showNextTimeText}}">
        <reactCheckbox 
        checked="{{.checkedShowNextTime}}" 
        on-onChange="@this.onShowNextTimeChanged(\$1)" />
    </reactFormLabel>

    <div class="footer-close-position-screen-btn">
        <terceraButton name="closebutton" text="{{.closeText}}" terceraButtonStyle="js-button-ok" on-btnClick="closeClick" />
        <terceraButton name="cancelbutton" text="{{.cancelText}}" terceraButtonStyle="js-button-gray25" on-btnClick="cancelClick" />
    </div>
</div>`;
// Exports
export default code;